/**
 * Functions for communication with a parent page embedding a page from DataEase.
 */

let debounceTimer = 0
let height

function updateWindow() {
  clearTimeout(debounceTimer)
  debounceTimer = setTimeout(sendHeight, 200);
}

function sendHeight() {
  debounceTimer = 0
  if (height) {
    window.top.postMessage({ height: height }, "*")
    console.log('sending height:', height)
  }
}

export function initPostHeight(elementID) {
  /**
   * Start a resize listener and send the new height via postMessage if the window is resized.
   * Messages are debounced to not send too many while resizing is happening.
   * Load this function in mounted() like initPostHeight('congressional-state-profiles')
   * 
   * @elementID is the HTML element ID that should be watched for resizing. This function expects to watch ONE element.
   */  
  const el = document.querySelector(`#${elementID}`)
  height = el.scrollHeight
  window.top.postMessage({ height: height }, "*")
  console.log('sending initial height:', height)

  const resizeObserver  = new ResizeObserver(entries => {
    entries.forEach(entry => {
      height = Math.ceil(entry.borderBoxSize[0].blockSize)
    })
    updateWindow()
  })
  resizeObserver.observe(el)
}
